class Score {
  constructor(p1, p2, board) {
    this.player1 = p1;
    this.player2 = p2;
    this.board = board;
  }
}

export default Score;
